<div [ngClass]="{ 'price-display-container': !allowCustomStyling }">
  <!-- TODO do this better in MIT-1542 -->
  <ng-container *ngIf="!priceUnavailable; else noPrice">
    <div
      class="price-top-info"
      *ngIf="topLabel"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'large-top-info': isCardView,
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start'
      }"
    >
      {{ topLabelDisplay }}
    </div>
    <div
      class="price-mid-info"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start',
        'large-mid-info': isCardView
      }"
    >
      <div *ngIf="!hasStairStepPricing || !isCardView">
        <ng-container *ngIf="multiFrequency; else oneFrequency">
          <ng-container *ngFor="let price of prices; let i = index">
            <div
              *ngIf="!contactSales && price.price && ((!allowNegativePrice && price.price > 0) || allowNegativePrice)"
            >
              <span *ngIf="i > 0">+</span>
              <glxy-frequency
                [value]="price.price | priceInDollars: currencyCode : 'en-US'"
                [currencyCode]="currencyCode | resolveCurrencyCode: 'en-US'"
                [form]="componentTextLength"
                [align]="align"
                [frequency]="price.frequency"
                [size]="size.toLowerCase()"
                [allowCustomStyling]="allowCustomStyling"
                [ngClass]="{
                  'large-inner-frequency': isCardView,
                  'link-popover': shouldShowPopover,
                  'align-center': align.toLowerCase() === 'center',
                  'negative-price': price.price < 0,
                  'green-price': price.price > 0 && showGreenPrice
                }"
                (mouseenter)="displayPopover()"
                (mouseleave)="showingPopover = false"
                [glxyPopover]="popover"
              ></glxy-frequency>
            </div>
            <span
              *ngIf="contactSales || (!price.price && prices.length === 1)"
              (mouseenter)="displayPopover()"
              (mouseleave)="showingPopover = false"
              [glxyPopover]="popover"
              [ngClass]="{
                'link-popover': shouldShowPopover
              }"
            >
              {{ overriddenValue }}
            </span>
          </ng-container>
        </ng-container>
        <ng-template #oneFrequency>
          <glxy-frequency
            *ngIf="
              !contactSales &&
              (price || (!price && alwaysShowNumber)) &&
              ((!allowNegativePrice && price >= 0) || allowNegativePrice)
            "
            [value]="price | priceInDollars: currencyCode : 'en-US'"
            [currencyCode]="currencyCode | resolveCurrencyCode: 'en-US'"
            [form]="componentTextLength"
            [align]="align"
            [frequency]="frequency"
            [size]="size.toLowerCase()"
            [allowCustomStyling]="allowCustomStyling"
            [ngClass]="{
              'large-inner-frequency': isCardView,
              'link-popover': shouldShowPopover,
              'align-center': align.toLowerCase() === 'center',
              'negative-price': price < 0,
              'green-price': price > 0 && showGreenPrice
            }"
            (mouseenter)="displayPopover()"
            (mouseleave)="showingPopover = false"
            [glxyPopover]="popover"
          ></glxy-frequency>
        </ng-template>

        <span
          *ngIf="contactSales || (!price && (!prices || prices.length <= 0)) || (price === 0 && shouldShowPopover)"
          (mouseenter)="displayPopover()"
          (mouseleave)="showingPopover = false"
          [glxyPopover]="popover"
          [ngClass]="{
            'link-popover': shouldShowPopover
          }"
        >
          {{ overriddenValue }}
        </span>
        <glxy-popover
          #popover
          [maxWidth]="'auto'"
          [isOpen]="showingPopover"
          [positions]="[
            popoverPositions.Left,
            popoverPositions.TopLeft,
            popoverPositions.BottomLeft,
            popoverPositions.Top,
            popoverPositions.Right
          ]"
          [padding]="'small'"
        >
          <glxy-popover-title>{{ popoverTitle }}</glxy-popover-title>
          <div *ngIf="hasStairStepPricing" class="stairstep-container">
            <billing-ui-stairstep-price-display
              [stairsteps]="stairSteps"
              [form]="componentTextLength"
              [align]="'start'"
              [frequency]="frequency"
              [size]="size.toLowerCase()"
              [currencyCode]="currencyCode"
            ></billing-ui-stairstep-price-display>
          </div>
          <span *ngIf="initialCommitment && recurringCommitment && hasStairStepPricing">
            <br />
            <strong>Commitment</strong>
            <br />
          </span>
          <span>{{ initialCommitment }}</span>
          <br *ngIf="initialCommitment && recurringCommitment" />
          <span>{{ recurringCommitment }}</span>
          <div *ngIf="hasDiscounts">
            <br *ngIf="(initialCommitment && recurringCommitment) || hasStairStepPricing" />
            <billing-ui-discount-display
              [discounts]="discounts"
              [currency]="currencyCode"
              [size]="size.toLowerCase()"
            ></billing-ui-discount-display>
          </div>
        </glxy-popover>
      </div>
      <div *ngIf="hasStairStepPricing && isCardView" class="stairstep-container">
        <billing-ui-stairstep-price-display
          [stairsteps]="stairSteps"
          [form]="componentTextLength"
          [align]="'start'"
          [frequency]="frequency"
          [size]="size.toLowerCase()"
          [currencyCode]="currencyCode"
        ></billing-ui-stairstep-price-display>
      </div>
    </div>
    <div
      class="price-bottom-info"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start'
      }"
      *ngIf="setupFee && setupFee > 0"
    >
      <span
        [ngClass]="{
          'large-setup-fee-value': isCardView
        }"
      >
        + {{ setupFee | currencyWithoutUSD: currencyCode : 'en-US' }}
      </span>
      <span [ngClass]="{ 'large-setup-fee-label': isCardView }">
        {{ setupFeeLabelKey | translate }}
      </span>
    </div>
    <div
      class="price-bottom-info"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start'
      }"
    >
      <ng-container *ngIf="this.prices?.length > 0 && this.fees?.length > 0; else displayFees">
        <div>
          <span
            [ngClass]="{
              'large-mgmt-fee-value': isCardView,
              'small-mgmt-fee': !isCardView
            }"
          >
            <span>+ Management fees</span>
          </span>
        </div>
      </ng-container>
      <ng-template #displayFees>
        <div *ngFor="let fee of this.fees">
          <div *ngIf="fee.amount > 0" id="fees">
            <span
              [ngClass]="{
                'large-mgmt-fee-value': isCardView,
                'small-mgmt-fee': !isCardView
              }"
            >
              <span id="fixed-fee-value" *ngIf="fee.amountType === FeeAmountType.FEE_AMOUNT_TYPE_FIXED">
                + {{ fee.amount | currencyWithoutUSD: currencyCode : 'en-US' }}
              </span>
              <span id="percentage-fee-value" *ngIf="fee.amountType === FeeAmountType.FEE_AMOUNT_TYPE_PERCENTAGE">
                + {{ fee.amount }}%
              </span>
            </span>
            <span [ngClass]="{ 'large-mgmt-fee-label': isCardView, 'small-mgmt-fee': !isCardView }">
              <span id="freq-short" *ngIf="componentTextLength === 'short'">
                {{ managementFeeFrequency }}
              </span>
              <span id="freq-verbose" *ngIf="componentTextLength === 'verbose'">
                &nbsp;{{ managementFeeFrequency }}
              </span>
              <span id="fee-label">
                {{ managementFeeLabelKey | translate }}
              </span>
            </span>
          </div>
        </div>
      </ng-template>
    </div>
    <div
      [ngClass]="{
        'large-bottom-text': isCardView,
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start'
      }"
      *ngIf="shouldShowBottomInfo"
      id="card-view-commitment"
    >
      <span>{{ initialCommitment }}</span>
      <br *ngIf="initialCommitment && recurringCommitment" />
      <span>{{ recurringCommitment }}</span>
    </div>
    <div
      class="card-view-discount"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start'
      }"
      *ngIf="shouldShowBottomInfo && hasDiscounts"
    >
      <billing-ui-discount-display
        [discounts]="discounts"
        [currency]="currencyCode"
        [size]="size.toLowerCase()"
      ></billing-ui-discount-display>
    </div>
  </ng-container>
  <ng-template #noPrice>
    <div
      [ngClass]="{
        'large-mid-info': isCardView,
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start'
      }"
    >
      {{ overriddenValue }}
    </div>
  </ng-template>
</div>
